module.exports = __webpack_public_path__ + "assets/icons/miracle-medicine.svg";